import { render, staticRenderFns } from "./businessShopDistributeRecord.vue?vue&type=template&id=1cb2e82a&scoped=true"
import script from "./businessShopDistributeRecord.vue?vue&type=script&lang=ts"
export * from "./businessShopDistributeRecord.vue?vue&type=script&lang=ts"
import style0 from "./businessShopDistributeRecord.vue?vue&type=style&index=0&id=1cb2e82a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb2e82a",
  null
  
)

export default component.exports